import {
  getEcommerceByIds,
  viewItemListEvent,
  selectItemEvent,
  getItemListNameFromBreadcrumb,
} from "@src/analytics";

export const getPropertyIdsFromSlides = (slides: Element[]): string[] => {
  return slides
    .map((slide) => {
      const propertyId = slide
        .querySelector(".container-nearby-item-favorite")
        ?.getAttribute("data-property-id");
      return propertyId || "";
    })
    .filter((propertyId) => !!propertyId);
};

export const pushViewItemListEventFromSlides = (
  slides: Element[],
  category?: string
) => {
  const propertyIds = getPropertyIdsFromSlides(slides);
  getEcommerceByIds(propertyIds, category).then((ecommerce) => {
    getItemListNameFromBreadcrumb().then((item_list_name) => {
      viewItemListEvent({
        ...ecommerce,
        item_list_name,
      });
    });
  });
};

export const pushSelectItemEventFromId = (
  propertyId: string,
  category?: string
) => {
  getEcommerceByIds([propertyId], category).then((ecommerce) => {
    getItemListNameFromBreadcrumb().then((item_list_name) => {
      selectItemEvent({
        ...ecommerce,
        item_list_name,
      });
    });
  });
};
